const config = {
    apiKey: "AIzaSyAiLH_Upcg5Xs5aEI9J4q1d_2NX4sW6ycc",
    authDomain: "superchat-5be60.firebaseapp.com",
    projectId: "superchat-5be60",
    storageBucket: "superchat-5be60.appspot.com",
    messagingSenderId: "764400184407",
    appId: "1:764400184407:web:afab7115f9f4fac9f7c712",
    measurementId: "G-MP9HJ63CRL"
}

export default config